module.exports = __webpack_public_path__ + "img/DISNEY_20bis.8dedea7e.jpg";